import { RxConversationAPI, ConversationAPI, checkStatus, json, RxMessagingAPI, MessagingAPI } from '@driftt/dapper'
import { keyBy } from 'utils/immutable'
import { parseMessage } from './models'
import { OrderedMap } from 'immutable'

export const api = {
  fetch(conversationId, limit) {
    return RxConversationAPI.get(`/conversations/${conversationId}/messages`, limit ? { withReceipts: true, limit } : { withReceipts: true })
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(data => keyBy(data.map(parseMessage), { acc: OrderedMap() }))
  },

  fetchPaginated(conversationId, from) {
    return RxConversationAPI.get(`/conversations/${conversationId}/messages/page`, from ? { limit: 35, from } : { limit: 35 })
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(data => {
        return {
          messages: keyBy(data.data.reverse().map(parseMessage), { acc: OrderedMap() }),
          pagination: data.pagination
        }
      })
  },

  create(conversationId, message) {
    return RxMessagingAPI.post(`/conversations/${conversationId}/messages`, message)
      .checkStatus()
      .retryWithBackoff(1)
      .mapResponse(parseMessage)
  },

  markRead(messageId) {
    return RxConversationAPI.post(`/messages/${messageId}/read`)
      .checkStatus()
      .retryWithBackoff()
  },

  bulkMarkRead(conversationId, messageIds) {
    return RxConversationAPI.post(`/messages/read-bulk`, { conversationId, messageIds })
      .checkStatus()
      .retryWithBackoff()
  },

  markReadUntil(messageId) {
    return RxConversationAPI.post(`/messages/${messageId}/read-until`)
      .checkStatus()
      .retryWithBackoff()
  },

  createMessageForNewConversation2(message) {
    return MessagingAPI.post('/messages', message)
      .then(checkStatus)
      .then(json)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/api.js